import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatDate } from "../utils/date";

export default function CitizenRequestDetailsModal({ open, onClose, data }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Request Details
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {!data ? (
          <Typography>No data found</Typography>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <strong>Name:</strong> {data.name || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Mobile:</strong> {data.mobile || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Email:</strong> {data.email || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Type:</strong> {data.request_type || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Citizen Type:</strong> {data.type || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Status:</strong> {data.status || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Tracking No:</strong> {data.tracking_no || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Division:</strong> {data.division_name || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>District:</strong> {data.district_name || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Upazila:</strong> {data.upazila_name || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Union:</strong> {data.union_name || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Ward No:</strong> {data.ward_no || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Village:</strong> {data.village || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Subject:</strong> {data.subject || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Appointment Date:</strong> {data.appointment_date || "-"}
            </Grid>
            <Grid item xs={12}>
              <strong>Message:</strong> {data.message || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Created At:</strong> {formatDate(data.created_at) || "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>Updated At:</strong> {formatDate(data.updated_at) || "-"}
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}